import { Stack, Text } from '@chakra-ui/react'

import theme from 'theme'

import type { StackProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

type Props = {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  text: string
  icon?: ReactNode
  color?: unknown
} & Omit<StackProps, 'children'>

const Heading = ({ as, text, icon, color, ...stackProps }: Props) => {
  return (
    <Stack className={`fbxHeading${as}`} direction="row" spacing="8px" align="center" {...stackProps}>
      {icon}
      <Text
        as={as}
        textStyle={as.toUpperCase()}
        color={color || theme.baseColors.text.default}
        noOfLines={1}
        userSelect="none"
      >
        {text}
      </Text>
    </Stack>
  )
}

export default Heading
